import React, { useMemo } from "react";
import { hasEcommerce } from "../utility/ecommerce";
import PdpBottomActions from "./elements/pdp-bottom-actions";
import useNoRtl from "../hooks/use-no-rtl";
import PdpWidgetPrice from "./elements/pdp-widget-price";
import { formatPrice } from "../utility/prices";
import classNames from "classnames";

const ProductDetailBottom = ({
  data,
  productTitle,
  priceData,
  scrolled,
  scrolledMobile,
  siteMetadata,
  storeLink,
}) => {
  const noRtl = useNoRtl("pdp");
  const enabledForLine = [undefined, "[]"].includes(
    data.pageLine?.lineConfigurationFieldSet?.isNotEcommerce?.[0]
  );

  const contributoRaee = useMemo(
    () =>
      priceData?.contributo_raee
        ? formatPrice(
            priceData.contributo_raee,
            priceData.sellingPrice.currency,
            siteMetadata.priceLanguage
          )
        : null,
    [priceData, siteMetadata.priceLanguage]
  );

  return (
    <div
      className={classNames(
        `product-detail__sticky-bottom${scrolled ? "" : " invisible"}`,
        scrolledMobile && "scrolled-mobile"
      )}
    >
      <div className="d-flex flex-column">
        <div
          className={
            !hasEcommerce && priceData === undefined ? "d-none" : "product-detail__title mb-0"
          }
          dangerouslySetInnerHTML={{ __html: productTitle }}
        ></div>

        <div className="d-flex justify-content-between">
          <div className="d-flex flex-column justify-content-center">
            {enabledForLine && !noRtl && (
              <PdpWidgetPrice priceData={priceData} contributoRaee={contributoRaee} bottom={true} />
            )}
          </div>
          <div className="d-flex flex-row align-items-center justify-content-between mb-1">
            <div
              className={
                !hasEcommerce && priceData === undefined ? "product-detail__title mb-0" : "d-none"
              }
              dangerouslySetInnerHTML={{ __html: productTitle }}
            ></div>
            {!noRtl && (
              <PdpBottomActions
                data={data}
                priceData={priceData}
                contributoRaee={contributoRaee}
                storeLink={storeLink}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetailBottom;
